<script setup lang="ts">
import { BButton, BCard } from 'bootstrap-vue-next';
import { ref } from 'vue';

import IssueRewardModal from '~/common/components/IssueRewardModal.vue';

const showModal = ref(false);
</script>

<template>
  <BCard
    title="Issue rewards"
    class="h-100"
  >
    <p class="text-body-secondary">
      Award swag credits to one or more contributors.
    </p>
    <BButton
      variant="outline-primary"
      @click="showModal = true"
    >
      Issue rewards
    </BButton>

    <IssueRewardModal v-model="showModal" />
  </BCard>
</template>
